<template>
  <div
    v-if="status"
    class="tw-w-fit tw-rounded-full tw-px-2.5 tw-py-1"
    :class="chipColors[status].backgroundColor"
  >
    <p class="tw-text-sm" :class="chipColors[status].textColor">
      {{ label || chipColors[status].label }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { ActionRequestStatus, ActionRequestScreeningStatus } from '@torticity/types'

interface ChipColor {
  backgroundColor: string
  textColor: string
  label: string
}

type StatusType = ActionRequestStatus | ActionRequestScreeningStatus

const chipColors: Record<StatusType, ChipColor> = {
  [ActionRequestStatus.SCREENED]: {
    backgroundColor: 'tw-bg-emerald-100',
    textColor: 'tw-text-emerald-800',
    label: 'Approved',
  },
  [ActionRequestStatus.SIGNATURE_DECLINED]: {
    backgroundColor: 'tw-bg-rose-100',
    textColor: 'tw-text-rose-800',
    label: 'Rejected',
  },
  [ActionRequestStatus.NEEDS_SCREENING]: {
    backgroundColor: 'tw-bg-indigo-100',
    textColor: 'tw-text-indigo-800',
    label: 'In review',
  },
  [ActionRequestStatus.PENDING_USER_ACTION]: {
    backgroundColor: 'tw-bg-amber-100',
    textColor: 'tw-text-amber-800',
    label: 'Action needed',
  },
  [ActionRequestScreeningStatus.APPROVED]: {
    backgroundColor: 'tw-bg-emerald-100',
    textColor: 'tw-text-emerald-800',
    label: 'Approved',
  },
  [ActionRequestScreeningStatus.REJECTED]: {
    backgroundColor: 'tw-bg-rose-100',
    textColor: 'tw-text-rose-800',
    label: 'Rejected',
  },
}

defineProps<{
  status: ActionRequestStatus | ActionRequestScreeningStatus | undefined
  label?: string
}>()
</script>
